export default {
  downloadPlural: 'Download source files',
  plural: 'Source files',
  pluralLowerCase: 'source files',
  uploadPlural: 'Upload source files',
  uploadSource: 'Upload source'
};
